import { ReactElement, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ItemTypes } from '~globals/types/enums';
import { useItemTypeInfo } from '~hooks/useItemTypeInfo';

import DescriptionWithIconBox from '../DescriptionWithIconBox';

import { OrderClientInfoDescriptionProps } from './types';
import {
  OrderClientInfoDescriptionContainer,
  OrderClientInfoDuplicatedChip,
} from './styles';

const OrderClientInfoDescription = ({
  description,
  itemTypeId,
  duplicated,
}: OrderClientInfoDescriptionProps): ReactElement => {
  const { icon, color, tooltipMessage } = useItemTypeInfo(
    itemTypeId ?? ItemTypes.Charge,
  );

  return (
    <OrderClientInfoDescriptionContainer>
      <DescriptionWithIconBox
        icon={
          itemTypeId?.toString() ? <FontAwesomeIcon icon={icon} /> : undefined
        }
        iconTooltip={tooltipMessage}
        iconPosition="right"
        iconColor={color}
        description={description}
        size={10}
        fontWeight="bold"
      />

      {duplicated && (
        <OrderClientInfoDuplicatedChip>
          <p>COPIA</p>
        </OrderClientInfoDuplicatedChip>
      )}
    </OrderClientInfoDescriptionContainer>
  );
};

export default memo(OrderClientInfoDescription);
